import React, { useState } from "react";

import { Dialog } from "primereact/dialog";
import DialogBox from "../../ProfileLanding/Resources/DialogBox";
import { Button } from "primereact/button";

export function ViewPaymentDetailsCarousel(props: any) {
  const [visible, setVisible] = useState(false);
  const footerContent = (
    <div>
      <Button label="OK" onClick={() => setVisible(false)} autoFocus />
    </div>
  );

  const handleClick = () => {
    setVisible(true);
  };

  return (
    <div
      className="card border-0 mb-0 pb-0"
      onClick={handleClick}
      style={{ cursor: "pointer" }}
    >
      <img
        src={props.web_url}
        className="w-100 img-fluid desktopImage"
        alt="Your pay matters"
      />
      <img
        src={props.mobile_url}
        className="w-100 img-fluid mobileImage"
        alt="Your pay matters"
      />
      <div className="card-img-overlay text-start">
        <div className="row mb-4">
          <div className="col-md-12 pt-3 ms-5">
            <div className="row mb-5">
              <div className="col-md-12 mb-3">
                <h1 className="text-start">Your pay matters</h1>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-md-12">
                <Button
                  className="me-0 text-black text-start d-block mt-3 text-white"
                  onClick={() => setVisible(true)}
                >
                  View Payment Details
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Dialog
        header="Your Pay Matters"
        visible={visible}
        style={{ width: "60vw" }}
        onHide={() => {
          setVisible(false);
        }}
        footer={footerContent}
      >
        <DialogBox></DialogBox>
      </Dialog>
    </div>
  );
}